import React from 'react'
import classes from './Availability.module.css';
import moment from 'moment'
class Availability extends React.Component{

    state={
        valueSelected : ""
    }
    render(){

        console.log(this.props.data)
       
        return(
            <div>
                <div style={{backgroundColor:"rgba(0,0,0, 0.6)",display:"block",
                    position:"absolute",top:0,right:0,left:0,bottom:0,margin:"auto",zIndex:"500"}}></div>
                 <div 
                    style={{height:"max-content",width:"400px",overflow: "auto",backgroundColor:"white",display:"block",
                    borderRadius:"10px",
                    position:"absolute",top:0,right:0,left:0,bottom:0,margin:"auto",zIndex:"600"}}>

                        <h3 style={{textAlign:"center",marginTop:"20px",color:"#00a99d",fontWeight:"bold"}}>Availability</h3>
                        <div style={{textAlign:"center",marginTop:"20px",overflow:"auto"}}>
                        <table cellPadding="5" style={{marginLeft:"50px",width:"300px",textAlign:"center",fontWeight:"bold"}}>
                            <tbody>
                           {this.props.data.length!=0? this.props.data.map((el,index)=>{
                               const obj = [el.availableSlot + ", " +  moment('2013-02-08 ' + el.startTime).format('h:mm A')+" - "+moment('2013-02-08 ' +  el.endTime).format('h:mm A')]
                              return ( <tr key={index}>
                                <td style={{textAlign:"start",width:"30px"}}> 
{/*                                 
                                <input name="val" value={obj} type="radio" onClick={(e)=>{this.props.onRadioSelect(e)}}/> */}
                                <label className={classes.profile}>
                                        <input name="val" value={obj} type="radio" onClick={(e)=>{this.props.onRadioSelect(e,this.props.obj); }} checked={this.props.text == obj} />
                                        <span className={classes.checkmark}></span>
                             </label>
                                
                                </td>
                                <td style={{textAlign:"start"}}>{el.availableSlot}</td>
                                <td style={{textAlign:"end"}}>{moment('2013-02-08 ' + el.startTime).format('h:mm A')} - {moment('2013-02-08 ' +  el.endTime).format('h:mm A')}</td> 
                             </tr>) 
                            }):<tr><td>No slot available</td></tr>}
                            </tbody>
                        </table>    
                        </div>
                        <div style={{width:"100%",textAlign:"center",marginTop:"10px",marginBottom:"15px"}}>
                        <button onClick={()=>{this.props.availabilityModalHandler()}} className={classes.okButton}>OK</button>
                        </div>
                        
                </div>
            </div> 
        )
    }
}

export default Availability
